import React, { useContext } from 'react';
import { useOutletContext } from 'react-router-dom';

import { SimpleAppBar } from '_lib/components/AppBar/SimpleAppBar';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';

import { AccountUserUpdate } from '../AccountUser/AccountUserUpdate';
import { AppRouteContext } from '../App/app.types';
import { AuthContext } from '../auth/authContext';
import { RouteErrorBoundary } from '../Routing/RouteErrorBoundary';
import { UserUpdate } from '../User/UserUpdate';

export const ProfileRoute = () => {
  const { appDrawerState } = useOutletContext<AppRouteContext>();

  const { authUserCacheResource } = useContext(AuthContext);

  const cachedAuthUserQuery = authUserCacheResource.useCacheQuery();

  return (
    <FlexBox sx={{ flexDirection: 'column', height: '100%', width: '100%' }}>
      <SimpleAppBar title='My Profile' onAppDrawerToggleClicked={appDrawerState?.openSlidingDrawer} />
      {cachedAuthUserQuery.data?.id ? (
        <>
          {cachedAuthUserQuery.data?.accountId ? (
            <AccountUserUpdate accountUserId={cachedAuthUserQuery.data.id} authUser={cachedAuthUserQuery.data} />
          ) : (
            <UserUpdate userId={cachedAuthUserQuery.data.id} authUser={cachedAuthUserQuery.data} />
          )}
        </>
      ) : (
        <RouteErrorBoundary appBarTitle='My Profile' errorTitle='Error Fetching Profile' />
      )}
    </FlexBox>
  );
};
